<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {groupBy, sortBy} from 'lodash'

import api from '@/api'
import {ApexOptions} from 'apexcharts'

@Component({})
export default class SpaceChartRoomActivity extends Vue {
  @Prop()
  spaceId: string

  interval: string = '30d'
  groupByTime: 'HOUR' | 'DAY' | 'MONTH' = 'DAY'

  promise: Promise<any> = null
  events: any[] = []

  get chartOptions(): ApexOptions {
    return {
      chart: {
        type: 'bar',
      },
      yaxis: [
        {
          title: {
            text: 'Total Motion Count',
          },
        },
      ],
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        y: {
          formatter(val) {
            return val + ' events'
          },
        },
      },
      plotOptions: {
        bar: {},
      },
      legend: {
        showForSingleSeries: true,
      },
      stroke: {
        width: 0,
      },
    }
  }

  get series(): any[] {
    /**
     * Event format:
     * {
     *     "uid": "DC3643B00E6B",
     *     "deviceType": "NAMI_SMART_PLUG",
     *     "eventType": "MOTION_COUNT",
     *     "locationId": "801",
     *     "value": 9,
     *     "timestamp": 1675296000
     * },
     */
    let grouped = groupBy(this.events, 'locationName')
    let ret = []

    for (let k in grouped) {
      ret.push({
        name: k,
        data: grouped[k].map((event) => {
          return [new Date(event.timestamp * 1000), event.value]
        }),
      })
    }

    ret = sortBy(ret, (series) => series.name)
    return ret
  }

  setTimeframe(interval: string, groupByTime: any) {
    this.events = []
    this.interval = interval
    this.groupByTime = groupByTime

    this.promise = api.spaces
      .chartRoomActivity(this.spaceId, {
        interval: interval,
        group_by_time: groupByTime,
      })
      .then((resp) => {
        this.events = resp.data.events
      })
  }

  mounted() {
    this.setTimeframe(this.interval, this.groupByTime)
  }
}
</script>
|
<template>
  <div>
    <h4 class="mt-5 mb-3">
      Room activity ({{ interval }})

      <span class="small">
        <b-link @click="setTimeframe('24h', 'HOUR')" class="ml-1 small">Day</b-link> &centerdot;
        <b-link @click="setTimeframe('7d', 'DAY')" class="ml-1 small">Week</b-link> &centerdot;
        <b-link @click="setTimeframe('30d', 'DAY')" class="ml-1 small">Month</b-link> &centerdot;
        <b-link @click="setTimeframe('90d', 'DAY')" class="ml-1 small">3 Months</b-link>
      </span>
    </h4>

    <div class="row mt-4">
      <div class="col">
        <div class="card card-body">
          <promised :promise="promise" :pending-delay="0">
            <template #pending>
              <div class="spinner-border mx-auto" role="status"></div>
            </template>
            <template #rejected>
              <div class="card-subtitle text-danger mt-2">Error loading data</div>
            </template>
            <template>
              <div v-if="events.length">
                <div>
                  <apexchart
                    v-if="events"
                    height="400"
                    :options="chartOptions"
                    :series="series"></apexchart>
                </div>
              </div>
              <div v-else>
                <div class="card-subtitle text-muted mt-2">No data</div>
              </div>
            </template>
          </promised>
        </div>
      </div>
    </div>
  </div>
</template>
